import React, { useState } from 'react';
import './Waitlist.css';

const Waitlist: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    companySize: '',
    paymentChallenges: '',
    countries: '',
    monthlyVolume: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
  };

  return (
    <div className="waitlist-page">
      <div className="waitlist-hero">
        <div className="container">
          <div className="waitlist-content">
            <div className="waitlist-text">
              <h1>Join the Waitlist</h1>
              <p className="subtitle">
                Be among the first to experience the future of cross-border payments
              </p>
              
              <div className="benefits-grid">
                <div className="benefit-item">
                  <div className="benefit-icon">⚡</div>
                  <div className="benefit-text">
                    <h3>Lightning Fast</h3>
                    <p>Send money globally in minutes, not days</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">💰</div>
                  <div className="benefit-text">
                    <h3>Ultra Low Fees</h3>
                    <p>Pay less than 1% in transaction fees</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">🌍</div>
                  <div className="benefit-text">
                    <h3>Global Reach</h3>
                    <p>Access markets worldwide with ease</p>
                  </div>
                </div>
                
                <div className="benefit-item">
                  <div className="benefit-icon">🔒</div>
                  <div className="benefit-text">
                    <h3>Bank-Grade Security</h3>
                    <p>Your transactions are protected by blockchain technology</p>
                  </div>
                </div>
              </div>
              
              <div className="contact-section">
                <h2>Ready to Get Started?</h2>
                <p>Join our exclusive waitlist and be the first to know when we launch.</p>
                
                {!isSubmitted ? (
                  <>
                    <div className="waitlist-form-card">
                      <div className="form-header">
                        <h3>Join the Waitlist</h3>
                        <p>Fill out the form below to secure your spot</p>
                      </div>
                      
                      <form onSubmit={handleSubmit} className="waitlist-form">
                        <div className="form-row">
                          <div className="form-group">
                            <label htmlFor="name">Full Name *</label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleInputChange}
                              required
                              placeholder="Enter your full name"
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="email">Email Address *</label>
                            <input
                              type="email"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                              required
                              placeholder="Enter your email"
                            />
                          </div>
                        </div>
                        
                        <div className="form-row">
                          <div className="form-group">
                            <label htmlFor="company">Company Name</label>
                            <input
                              type="text"
                              id="company"
                              name="company"
                              value={formData.company}
                              onChange={handleInputChange}
                              placeholder="Enter your company name"
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="companySize">Company Size</label>
                            <select
                              id="companySize"
                              name="companySize"
                              value={formData.companySize}
                              onChange={handleInputChange}
                            >
                              <option value="">Select company size</option>
                              <option value="1-10">1-10 employees</option>
                              <option value="11-50">11-50 employees</option>
                              <option value="51-200">51-200 employees</option>
                              <option value="201-500">201-500 employees</option>
                              <option value="500+">500+ employees</option>
                            </select>
                          </div>
                        </div>
                        
                        <div className="form-group">
                          <label htmlFor="paymentChallenges">Current Payment Challenges</label>
                          <textarea
                            id="paymentChallenges"
                            name="paymentChallenges"
                            value={formData.paymentChallenges}
                            onChange={handleInputChange}
                            placeholder="Describe your current payment challenges"
                            rows={3}
                          />
                        </div>
                        
                        <div className="form-row">
                          <div className="form-group">
                            <label htmlFor="countries">Countries You Send Money To</label>
                            <input
                              type="text"
                              id="countries"
                              name="countries"
                              value={formData.countries}
                              onChange={handleInputChange}
                              placeholder="e.g., USA, UK, India"
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="monthlyVolume">Monthly Transaction Volume</label>
                            <select
                              id="monthlyVolume"
                              name="monthlyVolume"
                              value={formData.monthlyVolume}
                              onChange={handleInputChange}
                            >
                              <option value="">Select volume</option>
                              <option value="<$10k">Less than $10,000</option>
                              <option value="$10k-$50k">$10,000 - $50,000</option>
                              <option value="$50k-$250k">$50,000 - $250,000</option>
                              <option value="$250k-$1M">$250,000 - $1,000,000</option>
                              <option value="$1M+">$1,000,000+</option>
                            </select>
                          </div>
                        </div>
                        
                        <button type="submit" className="submit-button">
                          Join Waitlist
                        </button>
                      </form>
                    </div>
                    
                    <div className="alternative-contact">
                      <p>Prefer to reach out directly?</p>
                      <a href="mailto:Gharsa.amin@kavodax.com" className="email-button">
                        <span className="email-icon">✉️</span>
                        <span className="email-text">Gharsa.amin@kavodax.com</span>
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="success-message">
                    <div className="success-icon">✅</div>
                    <h3>Thank you for joining our waitlist!</h3>
                    <p>We'll be in touch soon with updates about our launch.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Waitlist;
